import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const BrandCenter = () => {
    return <SharedDocumentsComponent permissionId="60" path="Brand Center" />
}